// material-ui
import { useTheme } from '@mui/material/styles';

// assets
import logoCheckingLight from 'assets/images/logo-checkin-vert.svg';
import logoCheckingDark from 'assets/images/logo-checkin-beige.svg';

// ==============================|| LOGO ||============================== //

const Logo = () => {
    const theme = useTheme();

    return (
        <img
            src={theme.palette.mode === 'dark' ? logoCheckingDark : logoCheckingLight}
            alt="Checkin Agency"
            width="170"
            style={{ height: 'auto', display: 'block' }}
        />
    );
};

export default Logo;
